var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Autocomplete,{ref:"autocompleteRef",attrs:{"state-key":_setup.usingStateKey,"fetch-suggestions":_setup.fetchSuggestions},on:{"change":_setup.handleInput,"select":_setup.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }